import firebase from "../services/firebase";

export const getUserToken = async () => {
  try {
    const user = firebase.currentUser();
    return user && (await user.getIdToken());
  } catch (e) {
    console.error(`There have some errors during fetching user token: ${e}`);
    return null;
  }
};
